import React from 'react';

import { handleInvitationRoute } from '/imports/modules/Invitations/presentation/routes';
import { zero } from '/imports/modules/Routing';
import { Authorise } from '/imports/ui/components/Authorise';
import { TopNavLayout } from '/imports/ui/layouts/TopNavLayout';
import { invitationHooks } from './presentation/hooks';

const HandleInvitation = React.lazy(() => import('./presentation/HandleInvitation'));

export const handleInvitationsRouter = zero().alt(
  handleInvitationRoute.parser.map((props) => (
    <Authorise
      deny={['exam', 'lti']}
      layout={(children) => <TopNavLayout selected="none">{children}</TopNavLayout>}
    >
      <HandleInvitation hooks={invitationHooks} {...props} />
    </Authorise>
  )),
);
